import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import SubAdminDetails from '../SubAdmins/SubAdminDetails/SubAdminDetails'
import {UsersListWrapper} from './users-list/UsersList'
import UsersDetailsPage from './UsersDetailsPage'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Transactions Management',
    path: '/apps/transactions',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const TransactionsManagement = () => {
  return (
    <Routes>
      {/* <Route element={<Outlet />}> */}
      <Route
        path='/'
        element={
          <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Transactions list</PageTitle>
            <UsersListWrapper />
          </>
        }
      />
      <Route path='transactions/details-page' element={<UsersDetailsPage />} />

      {/* </Route> */}
      <Route element={<Navigate to='/apps/transactions' />} />
    </Routes>
  )
}

export default TransactionsManagement
